export interface Activity {
  id: string
  type: 'document' | 'property' | 'verification' | 'hub' | 'form'
  title: string
  description: string
  timestamp: string
  status: 'completed' | 'pending' | 'in-progress'
}

const STORAGE_KEY = 'user_activities'
const MAX_ACTIVITIES = 50

export const activityLog = {
  addActivity(activity: Omit<Activity, 'id' | 'timestamp'>): void {
    const activities = this.getActivities()
    const newActivity: Activity = {
      ...activity,
      id: `activity_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString()
    }
    activities.unshift(newActivity)
    const trimmed = activities.slice(0, MAX_ACTIVITIES)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
    window.dispatchEvent(new CustomEvent('activityAdded', { detail: newActivity }))
  },

  getActivities(): Activity[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return []
      return JSON.parse(raw)
    } catch (error) {
      console.error('Failed to load activities:', error)
      return []
    }
  },

  clearActivities(): void {
    localStorage.removeItem(STORAGE_KEY)
  },

  logIdentityVerification(userName?: string): void {
    this.addActivity({
      type: 'verification',
      title: 'Identity Verified',
      description: userName ? `Identity verification completed for ${userName}` : 'Your identity verification was completed',
      status: 'completed'
    })
  },

  logSalesHubProgress(description: string): void {
    this.addActivity({
      type: 'hub',
      title: 'Sales Hub Progress',
      description,
      status: 'completed'
    })
  },

  logSalesHubComplete(): void {
    this.addActivity({
      type: 'hub',
      title: 'Sales Hub Submitted',
      description: 'Sales Hub has been submitted and is now in read-only mode. Identification Hub is now unlocked.',
      status: 'completed'
    })
  },

  logPropertyAdded(address: string, type: 'relinquished' | 'replacement'): void {
    this.addActivity({
      type: 'property',
      title: `${type === 'relinquished' ? 'Relinquished' : 'Replacement'} Property Added`,
      description: address,
      status: 'completed'
    })
  },

  logDocumentSigned(documentName: string): void {
    this.addActivity({
      type: 'document',
      title: `${documentName} Signed`,
      description: `You signed the ${documentName.toLowerCase()}`,
      status: 'completed'
    })
  },

  logDocumentUploaded(documentName: string): void {
    this.addActivity({
      type: 'document',
      title: `${documentName} Uploaded`,
      description: `You uploaded ${documentName}`,
      status: 'completed'
    })
  },

  logFormCompleted(formName: string): void {
    this.addActivity({
      type: 'form',
      title: `${formName} Completed`,
      description: `You completed the ${formName}`,
      status: 'completed'
    })
  }
}




